"use strict";

(function(z, Backbone){

    var ProjectsRepresentativesCollection = Backbone.Collection.extend({
        // nothing
    });

    z.ProjectsRepresentativesCollection = ProjectsRepresentativesCollection;

})(window.z = window.z || {}, Backbone);